module.exports = __webpack_public_path__ + "static/media/article-b.8c2440bf.jpg";